import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.title',
    defaultMessage: 'Order Page',
  },
  priority: {
    id: 'containers.OrderPage.priority',
    defaultMessage: 'Priority',
  },
  usageExtension: {
    id: 'containers.OrderPage.usageExtension',
    defaultMessage: 'Ext.',
  }
})
